import { Grid, styled } from "@mui/material";
import ChromeTabs, { ChromeTab } from "components/UI/SubTabs/ChromeTabs";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import Requeue from "./Requeue/Requeue";
import AutoRequeue from "./AutoRequeue/AutoRequeue";
import FileTimeline from "./Timeline/FileTimeline";
import Ops from "./Ops/Ops";
import RbcToTsQuery from "./RbcToTsQuery/RbcToTsQuery";
import SagaInspector from "./SagaInspector/SagaInspector";

const TabRootDiv = styled("div")(() => ({
    width: "100%",
    height: "calc(100% - 100px)",
    overflow: "hidden",
}));

const PipelineToolsNav = observer(() => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState<number>();

    const tabs: Array<ChromeTab> = [
        {
            label: "Re-Queue",
            route: "/admin/pipeline/requeue",
        },
        {
            label: "Automated Re-Queue",
            route: "/admin/pipeline/auto-requeue",
        },
        {
            label: "Timeline",
            route: "/admin/pipeline/timeline",
        },
        {
            label: "Ops Dashboard",
            route: "/admin/pipeline/opsdashboard",
        },
        {
            label: "RBC To TSQuery",
            route: "/admin/pipeline/rbc",
        },
        {
            label: "Saga Inspector",
            route: "/admin/pipeline/sagas",
        },
    ];

    const updateTab = (index: number) => {
        setActiveTab(index);
        navigate({
            pathname: tabs[index].route!,
            search: `${location.search}`,
        });
    };

    useEffect(() => {
        if (activeTab === undefined) {
            let index = tabs.findIndex((tab) =>
                tab.route?.includes(location.pathname),
            );
            updateTab(Math.max(index, 0));
        }
    });

    return (
        <>
            <Grid container>
                <Grid item container>
                    <ChromeTabs
                        tabs={tabs}
                        activeTabIndex={activeTab}
                        onChange={updateTab}
                    />
                </Grid>
            </Grid>
            <Routes>
                <Route
                    path="requeue"
                    element={
                        <>
                            <TabRootDiv>
                                <Requeue />
                            </TabRootDiv>
                        </>
                    }
                />
                <Route
                    path="auto-requeue"
                    element={
                        <>
                            <TabRootDiv>
                                <AutoRequeue />
                            </TabRootDiv>
                        </>
                    }
                />
                <Route
                    path="timeline"
                    element={
                        <>
                            <TabRootDiv>
                                <FileTimeline />
                            </TabRootDiv>
                        </>
                    }
                />
                <Route
                    path="opsdashboard"
                    element={
                        <>
                            <TabRootDiv>
                                <Ops />
                            </TabRootDiv>
                        </>
                    }
                />
                <Route
                    path="rbc"
                    element={
                        <>
                            <TabRootDiv>
                                <RbcToTsQuery />
                            </TabRootDiv>
                        </>
                    }
                />
                <Route
                    path="sagas"
                    element={
                        <>
                            <TabRootDiv>
                                <SagaInspector />
                            </TabRootDiv>
                        </>
                    }
                />
            </Routes>
        </>
    );
});

export default PipelineToolsNav;
